import React from "react";
import { noop } from "utils/General";
import Header from "Portal/NewPortal/HeaderBar/MobileMenuFlyOver/View/Header";
import Body from "Portal/NewPortal/HeaderBar/MobileMenuFlyOver/View/Body";
import { Div } from "components/Base";
import { getEnabledSectionsMenu } from "Portal/NewPortal/PortalHome/selectors";
import { connect } from "react-redux";

const decorate = connect(state => ({
  categories: getEnabledSectionsMenu(state)
}));

const MobileSwitchPortal = ({ handleClose = noop, categories }) => {
  return (
    <div>
      <Header
        hideModal={handleClose}
        name={`${
          categories.length > 1 ? `Pages (${categories.length - 1})` : "Page"
        }`}
        xSize={16}
        height={56}
      />
      <Div style={{ height: "100%", padding: "0 20px 20px 20px" }}>
        <Body hideModal={handleClose} isMobileFlyover={true} />
      </Div>
    </div>
  );
};

export default decorate(MobileSwitchPortal);
